module.exports = __webpack_public_path__ + "static/13-52d2e02077b29e3dfb977757c4d84b80.jpg";